import { LoadMore } from './load-more';

export default LoadMore;
